"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelephoneTitle = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
var _defaultTranslations = require("../../constants/defaultTranslations");
var _TranslationKey = require("../../models/TranslationKey");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const getTelephoneMessage = phoneDisplayMode => {
  switch (phoneDisplayMode) {
    case 0:
      return {
        id: _TranslationKey.TranslationKey.telephoneTitle,
        defaultMessage: _defaultTranslations.defaultTranslations.telephoneTitle
      };
    case 2:
      return {
        id: _TranslationKey.TranslationKey.addPhoneNumber,
        defaultMessage: _defaultTranslations.defaultTranslations.addPhoneNumber
      };
    case 3:
      return {
        id: _TranslationKey.TranslationKey.editPhoneNumber,
        defaultMessage: _defaultTranslations.defaultTranslations.editPhoneNumber
      };
    case 4:
      return {
        id: _TranslationKey.TranslationKey.verifyPhone,
        defaultMessage: _defaultTranslations.defaultTranslations.verifyPhone
      };
    default:
      return null;
  }
};
const TelephoneTitle = ({
  phoneDisplayMode,
  sectionType = _constants.SectionType.Profile
}) => {
  const message = getTelephoneMessage(phoneDisplayMode);
  const isCheckout = sectionType === _constants.SectionType.Checkout;
  if (!message || isCheckout) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    mb: 6,
    variant: "h6",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: message.id,
      defaultMessage: message.defaultMessage
    })
  });
};
exports.TelephoneTitle = TelephoneTitle;
